import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { TripStatusEditModal } from './components/trip-status-edit-modal';
import type { ITripStatusEditComponentProps } from './types';

export const TripStatusEditComponent: React.FC<ITripStatusEditComponentProps> = (props) => {
  const { trip } = props;
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <Button icon={<RocketOutlined />} onClick={handleOpen}>
        {t('trip:status')}
      </Button>
      <TripStatusEditModal trip={trip} isOpen={isModalOpen} onClose={handleClose} />
    </>
  );
};

export const TripStatusEdit = withRoleGuard<ITripStatusEditComponentProps>(TripStatusEditComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.transport_manager,
  UserRole.storekeeper,
]);
